import React from "react";

function CustomTag() {
    const greeting = "Hello World";
    return(<span className="container">{greeting}</span>)
}
export default CustomTag;